"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormattedNumber = void 0;
var getFormattedNumber = function (_a) {
    var value = _a.value, _b = _a.thousandSeparator, thousandSeparator = _b === void 0 ? '.' : _b, _c = _a.decimalSeparator, decimalSeparator = _c === void 0 ? ',' : _c, _d = _a.significantDigits, significantDigits = _d === void 0 ? 0 : _d, _e = _a.showTrailingZeros, showTrailingZeros = _e === void 0 ? false : _e, _f = _a.symbol, symbol = _f === void 0 ? 'kr.' : _f, _g = _a.showSymbol, showSymbol = _g === void 0 ? true : _g, _h = _a.symbolPosition, symbolPosition = _h === void 0 ? 'after' : _h, _j = _a.showSymbolSpace, showSymbolSpace = _j === void 0 ? true : _j;
    var significantDigitsExponent = Math.pow(10, significantDigits);
    var valueWithSignificantDigits = showTrailingZeros
        ?
            value.toFixed(significantDigits)
        :
            "".concat(Math.round((value + Number.EPSILON) * significantDigitsExponent) / significantDigitsExponent);
    var _k = valueWithSignificantDigits.toString().split('.'), integerPart = _k[0], fractionalPart = _k[1];
    var formattedIntegerPart = "".concat(integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator));
    var formattedValue = fractionalPart
        ? "".concat(formattedIntegerPart).concat(decimalSeparator).concat(fractionalPart)
        : formattedIntegerPart;
    if (showSymbol && Boolean(symbol)) {
        var formattedValueWithSymbol = symbolPosition === 'after' ? "".concat(formattedValue, " ").concat(symbol) : "".concat(symbol, " ").concat(formattedValue);
        return showSymbolSpace ? formattedValueWithSymbol : formattedValueWithSymbol.replace(' ', '');
    }
    return formattedValue;
};
exports.getFormattedNumber = getFormattedNumber;
//# sourceMappingURL=NumberFormat.js.map